import { TextResources } from "@portal/assets/text/TextResources";
import { IPortfolio } from "@portal/types/api/IPortfolio";
import { SelectOption } from "@portal/components/atoms/selectBox";
import { Variants } from "@portal/components/atoms/v2/typography/types";
import Typography from "@portal/components/atoms/v2/typography";

interface Props {
  spaced: boolean | undefined;
  variant: Variants;
}
/**
 * Component to add an option to create an ASK account to the portfolio drop-down list.
 * @param interface
 * @returns a clickable option to create ASK.
 */
export const CreateAsk = ({ spaced, variant }: Props) => {
  const askAccount = { portfolioId: "0" } as IPortfolio;

  return (
    <SelectOption key={`ask`} selectKey={`create-ask`} value={askAccount} spaced={spaced}>
      <span className="truncate">
        <Typography variant={variant}>{TextResources.ACCOUNT_CREATE_ASK}</Typography>
      </span>
    </SelectOption>
  );
};
